import { countries } from "@redotech/locale/countries";
import {
  defineSchema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";
import {
  exampleOrderTrackingSchemaInstance,
  orderTrackingSchema,
} from "./order-tracking";

export const trackingPageFlowSchema = defineSchema({
  fields: {
    ...orderTrackingSchema.fields,
    // TODO: Remove after DB migration renames orderId → externalOrderId
    orderId: { dataType: "Text", documentation: "The Shopify order ID." },
    redoOrderId: {
      dataType: "Text",
      documentation:
        "Redo's own identifier for the order, which is not the order ID in your store platform.",
    },
    // TODO: Remove after DB migration renames destinationCountry → customerCountry
    destinationCountry: {
      dataType: "Enum",
      values: countries.map((country) => country.code),
      documentation: "The destination country code for the order.",
    },
    commerceCloudLoyaltyTier: {
      dataType: "Maybe Text",
      documentation:
        "The ordering customer's Commerce Cloud (SFCC) loyalty tier, if any.",
    },
  },
});

export const exampleTrackingPageFlowSchemaInstance: SchemaInstance<
  typeof trackingPageFlowSchema
> = {
  ...exampleOrderTrackingSchemaInstance,
  orderId: "order-123",
  redoOrderId: "redo-order-123",
  destinationCountry: "US",
  commerceCloudLoyaltyTier: "Gold",
};
